import { render } from "./App.vue?vue&type=template&id=9e5325fa"
const script = {}

import "./App.vue?vue&type=style&index=0&id=9e5325fa&lang=scss"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__